import { gql } from 'graphql-request'

export const SubmitOfferGql = gql`
  mutation submitOffer($offerId: UUID!, $woolLotOfferDecisions: [WoolLotOfferDecisionInput!]!) {
    submitOffer(request: { offerId: $offerId, woolLotOfferDecisions: $woolLotOfferDecisions }) {
      errorMessage
      success
    }
  }
`
